<template>
  <div id="activityDataExport">
    <div class="common_contentBox">
      <div class="title">导出内容筛选</div>
      <el-form label-position="top" label-width="80px" :model="formData">
        <div class="row">
          <el-form-item label="活动类型:">
            <el-select v-model="formData.region" placeholder="请选择">
              <el-option label="区域一" value="shanghai" />
              <el-option label="区域二" value="beijing" />
            </el-select>
          </el-form-item>
          <el-form-item label="细分市场:">
            <el-select v-model="formData.region" placeholder="请选择">
              <el-option label="区域一" value="shanghai" />
              <el-option label="区域二" value="beijing" />
            </el-select>
          </el-form-item>
          <el-form-item label="总金额:">
            <el-input v-model="formData.type" />
          </el-form-item>
          <el-form-item label="单据年份:">
            <el-select v-model="formData.region" placeholder="请选择">
              <el-option label="区域一" value="shanghai" />
              <el-option label="区域二" value="beijing" />
            </el-select>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="操作状态:">
            <el-select v-model="formData.region" placeholder="请选择">
              <el-option label="区域一" value="shanghai" />
              <el-option label="区域二" value="beijing" />
            </el-select>
          </el-form-item>
          <el-form-item label="流程状态:">
            <el-select v-model="formData.region" placeholder="请选择">
              <el-option label="区域一" value="shanghai" />
              <el-option label="区域二" value="beijing" />
            </el-select>
          </el-form-item>
          <el-form-item label="选择时间类型:">
            <el-select v-model="formData.region" placeholder="请选择">
              <el-option label="区域一" value="shanghai" />
              <el-option label="区域二" value="beijing" />
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间:">
            <el-select v-model="formData.region" placeholder="请选择">
              <el-option label="区域一" value="shanghai" />
              <el-option label="区域二" value="beijing" />
            </el-select>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="结束时间:">
            <el-select v-model="formData.region" placeholder="请选择">
              <el-option label="区域一" value="shanghai" />
              <el-option label="区域二" value="beijing" />
            </el-select>
          </el-form-item>
          <el-form-item label="费用项目:">
            <el-select v-model="formData.region" placeholder="请选择">
              <el-option label="区域一" value="shanghai" />
              <el-option label="区域二" value="beijing" />
            </el-select>
          </el-form-item>
          <el-form-item label="部门:">
            <el-select v-model="formData.region" placeholder="请选择">
              <el-option label="区域一" value="shanghai" />
              <el-option label="区域二" value="beijing" />
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <div class="buttonBar">
        <el-button type="primary">重置</el-button>
        <el-button type="primary">导出</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActivityDataExport',
  data () {
    return {
      formData: {}
    };
  }
};
</script>

<style lang="scss" scoped>
#activityDataExport{
  >div{
    >.title{
      margin: 10px 0 20px;
      font-size: 16px;
      font-weight: 600;
    }
    >.el-form{
      >.row{
        &:after{
          content: "";
          display: block;
          clear: both;
        }
        >.el-form-item{
          width: 250px;
          float: left;
          margin-left: 50px;
          margin-bottom: 15px;
        }
      }
    }
    >.buttonBar{
      padding: 50px;
    }
  }
}
</style>
